export default __webpack_public_path__ + "static/media/Rain.06e9ef79.gif";